
import { Button } from '@/components/ui/button';

const MobileCTASection = () => {
  return (
    <section className="py-20 bg-nexx-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Make the Switch?
        </h2>
        <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
          Get started with T-Mobile for Business through Next Telecom and experience the difference 
          of working with an authorized partner focused on your success.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            size="lg" 
            variant="outline" 
            className="border-pink-600 text-pink-600 hover:bg-pink-600 hover:text-white"
            data-tally-open="mejLOk" 
            data-tally-emoji-text="👋" 
            data-tally-emoji-animation="wave"
          >
            Get Started with T-Mobile for Business
          </Button>
        </div>
      </div>
    </section>
  );
};

export default MobileCTASection;
